// @flow
import * as React from "react";

type Contexto = {
  exibirSelecaoPeriodo: boolean,
  exibirSelecaoPeriodicidade: boolean,
  exibirSelecaoAjusteDias: boolean,
};

const ContextoEdicaoMedidas = React.createContext<Contexto>({
  exibirSelecaoPeriodo: true,
  exibirSelecaoPeriodicidade: true,
  exibirSelecaoAjusteDias: true,
});

export const ProvedorDoContextoEdicaoMedidas = ({ children, ...props }: *) => (
  <ContextoEdicaoMedidas.Provider value={props}>
    {children}
  </ContextoEdicaoMedidas.Provider>
);

export const useEdicaoDeMedida = () => React.useContext(ContextoEdicaoMedidas);

export const comEdicaoDeMedida = (Componente: *) => {
  return function ComponenteComEdicaoMedida(props: *) {
    return (
      <ContextoEdicaoMedidas.Consumer>
        {ctx => <Componente {...ctx} {...props} />}
      </ContextoEdicaoMedidas.Consumer>
    );
  };
};
